import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { ConfigService } from 'src/app/services/config.service';
import { ToolsService } from 'src/app/services/tools.service';

@Component({
  selector: 'app-tutorial',
  templateUrl: './tutorial.component.html',
  styleUrls: ['./tutorial.component.scss'],
})
export class TutorialComponent implements OnInit {


  doNotShowAgain: FormControl = new FormControl(false);
  tutorialImg: any;
  isLoading = true;

  constructor(private modalCtrl: ModalController, private toolsService: ToolsService, public configService: ConfigService) { }

  ngOnInit() {
    if (this.configService.mall) {
      this.tutorialImg = this.configService.mall.registration_tutorial;
    } else {
      this.configService.mallLoaded.subscribe((mall) => {
        this.tutorialImg = mall?.registration_tutorial || 'assets/img/how-to.webp';
      });
    }
  }


  close() {
    if(this.doNotShowAgain) this.toolsService.setShowTutorialAgain(false);
    this.modalCtrl.dismiss();
  }


  onImageLoadStart() {
    this.isLoading = true;
  }

  onImageLoaded() {
    this.isLoading = false;
  }

  onImageError() {
    console.warn('Error al cargar la imagen del tutorial');
    this.isLoading = false;
  }

}
